<template>
  <section class="space-y-4">
    <h2 class="text-lg font-bold">Nieuwsbrieven</h2>

    <div class="space-y-2">
      <a
        v-for="file in visibleFiles"
        :href="`/api/files/${file.uuid}`"
        target="_blank"
        class="flex items-center gap-2 rounded-tr-lg border border-l-2 py-2 pl-3 pr-4 hover:bg-neutral-100 dark:border-gray-800 dark:text-gray-300 dark:hover:bg-gray-800"
      >
        <DocumentTextIcon class="size-5" />
        <span class="grow truncate">{{ file.title }}</span>
        <span class="text-sm">{{ file.year }}</span>
      </a>

      <button
        v-if="showButton"
        @click="showAll = true"
        class="w-full appearance-none rounded-lg border bg-none py-2 text-center text-sm hover:bg-neutral-100 dark:border-gray-800 dark:text-gray-300 dark:hover:bg-gray-800"
      >
        Meer nieuwsbrieven
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { DocumentTextIcon } from '@heroicons/vue/24/outline'
  import { computed, ref } from 'vue'

  const minAmount = import.meta.env.DEV ? 1 : 2
  const showButton = computed(() => {
    if (showAll.value) {
      return false
    }

    return files.value.length > minAmount
  })

  const showAll = ref(false)
  const files = ref<NMNewsletter[]>([])

  const visibleFiles = computed(() => {
    if (showAll.value) {
      return files.value
    }

    return files.value.slice(0, minAmount)
  })

  const loadFiles = async () => {
    const searchParams = new URLSearchParams({ kind: 'newsletter' })
    const resp = await fetch('/api/files?' + searchParams.toString())

    if (resp.ok) {
      files.value = await resp.json()
    }
  }

  loadFiles()
</script>
